// @flow
import * as React from 'react';
import { TabHr, TabsDiv } from './TabStyles';
import { type ReactObjRef } from '../utilities/types';

type Props = { children: React.Node, className?: string };
type State = {
  borderLeft: number,
  borderWidth: number,
  transitionActive: boolean
};

// This component adds a border to routed tabs (using class .active)
class AnimatingBorder extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.tabContainerRef = React.createRef();
    this.state = {
      borderLeft: 0,
      borderWidth: 0,
      transitionActive: false
    };
  }
  transitionTimer: TimeoutID;
  tabContainerRef: ReactObjRef<'div'>;

  findActive = () => {
    if (!this.tabContainerRef.current) {
      return;
    }
    const { children } = this.tabContainerRef.current;
    for (let i = 0; i < children.length; i++) {
      const el = children[i];
      if (el.className.includes('active')) {
        this.setState({
          borderLeft: el.offsetLeft,
          borderWidth: el.offsetWidth
        });
      }
    }
    return 0;
  };

  componentDidMount() {
    this.findActive();
    this.transitionTimer = setTimeout(() => {
      this.setState({ transitionActive: true });
    }, 200);
    window.addEventListener('resize', this.findActive);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.findActive);
    clearTimeout(this.transitionTimer);
  }

  render() {
    return (
      <TabsDiv ref={this.tabContainerRef} className={this.props.className}>
        {this.props.children}
        <TabHr
          transitionActive={this.state.transitionActive}
          style={{
            left: this.state.borderLeft,
            width: this.state.borderWidth
          }}
        />
      </TabsDiv>
    );
  }
}

export default AnimatingBorder;
